import React, {useEffect, useState} from 'react';
import {Route, Switch, useHistory} from "react-router-dom";
import Toolbar from "../../partialViews/toolbar/Toolbar";
import {IsF, IsLP, IsLP_MP_SP, IsM, IsMP, IsSP, IsT} from "my-styles/media/media";
import Footer from "../../partialViews/footer/Footer";
import Profile from "../profile/Profile";
import AddressList from "../address/AddressList";
import AddressDetail from "../address/AddressDetail";
import Aggrement from "../aggrement/Aggrement";
import Download from "../download/Download";
import Suggestion from "../suggestion/Suggestion";
import AddTicket from "../suggestion/AddTicket";
import Basket from "../basket/Basket";
import GridCategory from "../category/GridCategory";
import Category from "../category/Category";
import ProductDetail from "../product/ProductDetail";
import OrderRegister from "../orderRegister/OrderRegister";
import Orders from "../order/Orders";
import OrderDetail from "../order/OrderDetail";
import ContactUs from "../contactUs/ContactUs";
import InviteFriend from "../invite/InviteFriend";
import InvitedByFriend from "../invite/InvitedByFriend";
import DriverLocation from "../order/DriverLocation";
import Rewards from "../reward/Rewards";
import Notifications from "../notification/Notifications";
import Home from "../home/Home";
import DownloadApp from "../main/DownloadApp";
import Landing from "../landing/Landing";
import Login from "../login/Login";
import Verify from "../verify/Verify";
import OrderRate from "../orderRate/OrderRate";
import messages from "res/messages/farsi";
import {Divider, Grow, Paper, Popper} from "@material-ui/core";
import IconTitleButton from "components/buttons/IconTitleButton";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import {categoryViewModel} from "../../../viewModels/Category.viewModel";
import CrossfadeImage from "react-crossfade-image";
import {Animated} from "react-animated-css";
import CircleIconButton from "components/buttons/CircleIconButton";
import BeforePayment from "../payment/BeforePayment";
import AfterPayment from "../payment/AfterPayment";
import Supplier from "../supplier/Supplier";

import ICUserAccount from "@mui/icons-material/PersonOutline";
import ICAddress from "@mui/icons-material/Map";
import ICReward from "@mui/icons-material/CardGiftcard";
import ICInvite from "@mui/icons-material/MapsUgcOutlined";
import ICTicket from "res/images/message.png";
import ICLogOut from "@mui/icons-material/Logout";
import ICArrow from "res/images/top_arrow.png";
import TicketDetail from "../suggestion/TicketDetail";
import AnswerTicket from "../suggestion/AnswerTicket";
import Wallet from "../wallet/Wallet";
import ICWalllet from '@mui/icons-material/AccountBalanceWalletOutlined';
import Article from "../article/Article";
import BeforeWalletPayment from "../payment/BeforeWalletPayment";
import AfterWalletPayment from "../payment/AfterWalletPayment";
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import TopBanner from "../home/TopBanner";
import CommentList from "../product/CommentList";

export default function Shared(props) {

    const routes = [
        {
            id: 1,
            path: '/',
            exact: true,
            component: Home
        },
        {
            id: 2,
            path: '/profile',
            component: Profile
        },
        {
            id: 3,
            path: '/addressList',
            component: AddressList
        },
        {
            id: 4,
            path: '/addressDetail',
            component: AddressDetail
        },
        {
            id: 5,
            path: '/aggrement',
            component: Aggrement
        },
        {
            id: 6,
            path: '/download',
            component: Download
        },
        {
            id: 7,
            path: '/suggestion',
            component: Suggestion
        },
        {
            id: 8,
            path: '/basket',
            component: Basket
        },
        {
            id: 9,
            path: '/gridCategory',
            component: GridCategory
        },
        {
            id: 10,
            path: '/category',
            component: Category
        },
        {
            id: 11,
            path: '/productDetail',
            component: ProductDetail
        },
        {
            id: 12,
            path: '/orderRegister',
            component: OrderRegister
        },
        {
            id: 13,
            path: '/orders',
            component: Orders
        },
        {
            id: 14,
            path: '/orderDetail',
            component: OrderDetail
        },
        {
            id: 15,
            path: '/contactUs',
            component: ContactUs
        },
        {
            id: 16,
            path: '/inviteFriend',
            component: InviteFriend
        },
        {
            id: 17,
            path: '/invitedByFriend',
            component: InvitedByFriend
        },
        {
            id: 18,
            path: '/driverLocation',
            component: DriverLocation
        },
        {
            id: 19,
            path: '/rewards',
            component: Rewards
        },
        {
            id: 20,
            path: '/notifications',
            component: Notifications
        },
        {
            id: 21,
            path: '/beforePayment',
            component: BeforePayment
        },
        {
            id: 22,
            path: '/supplier',
            component: Supplier
        },
        {
            id: 23,
            path: '/addTicket',
            component: AddTicket
        },
        {
            id: 24,
            path: '/ticketDetail',
            component: TicketDetail
        },
        {
            id: 25,
            path: '/answerTicket',
            component: AnswerTicket
        },
        {
            id: 26,
            path: '/wallet',
            component: Wallet
        },
        {
            id: 27,
            path: '/article',
            component: Article
        },
        {
            id: 28,
            path: '/beforeWalletPayment',
            component: BeforeWalletPayment
        },
        {
            id: 29,
            path: '/commentList',
            component: CommentList
        }

    ]
    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [user, setUser] = useState()
    const [logoutDialogShowStatus, setLogoutDialogShowStatus] = useState(false)
    const [sideMenuState, setSideMenuState] = React.useState({left: false})
    const [profileAnchor, setProfileAnchor] = useState(null)
    const [profileButtonOver, setProfileButtonOver] = useState(false)
    const [profilePopperOver, setProfilePopperOver] = useState(false)
    const [categoryAnchor, setCategoryAnchor] = useState(null)
    const [categoryButtonOver, setCategoryButtonOver] = useState(false)
    const [goToTopShowStatus, setGoToTopShowStatus] = useState(false)
    const [categoryPopperOver, setCategoryPopperOver] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedCategoryChild, setSelectedCategoryChild] = useState(null)
    const [downloadAppState, setDownloadAppState] = React.useState(parseInt(localStorage.getItem('clickOnDownloadApp')))
    const [dynamicData, setDynamicData] = useState([])
    const [banners, setBanners] = useState([])
    const [bannerHeight, setBannerHeight] = useState(0)
    const onShowProfileMenu = (event) => {
        setProfileAnchor(event.currentTarget)
        setProfileButtonOver((prevOpen) => !prevOpen)
    }
    const onHideProfileMenu = () => {
        setProfileButtonOver(false)
    }
    const onProfilePopperMouseEnter = () => {
        setProfilePopperOver(true)
    }
    const onProfilePopperMouseOut = () => {
        setProfilePopperOver(false)
    }
    const onShowCategoryMenu = (event) => {
        setCategoryAnchor(event.currentTarget)
        setCategoryButtonOver((prevOpen) => !prevOpen)
    }
    const onHideCategoryMenu = () => {
        setCategoryButtonOver(false)
    }
    const onCategoryPopperMouseEnter = () => {
        setCategoryPopperOver(true)
    }
    const onCategoryPopperMouseOut = () => {
        setCategoryPopperOver(false)
    }
    const onShowSideMenu = (anchor, open) => (event) => {
        if (!authenticationViewModel.isLogin) {
            onHideProfileMenu()
            props.onNavigate(history, '/login')
        } else {
            if (event && event.type === 'keydown' && (event.key === 'tab' || event.key === 'Shift')) {
                return
            }
            setSideMenuState({...sideMenuState, [anchor]: open})
        }
    }
    const onShowRewardsPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/rewards')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }

    const onShowWalletPage=()=>{
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/wallet?p=1')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }
    const onShowloginOrProfilePage = () => {
        onHideProfileMenu()
        onProfilePopperMouseOut()
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/profile')
        } else {
            props.onNavigate(history, '/login')
        }
    }
    const onShowAddressPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/addressList')
        } else {
            props.onNavigate(history, '/login')
        }
    }
    const onShowNotificationPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/notifications?p=1')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }
    const onShowOrdersPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/orders?s=' + -1 + '&p=1')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }
    const onShowSuggestionPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/suggestion?p=1')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }
    const onShowAddTicketPage = () => {
        if (authenticationViewModel.isLogin) {
            props.onNavigate(history, '/addTicket')
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, '/login')
                }
            })
        }
    }
    const onShowLoginPage = () => {
        onHideProfileMenu()
        if (!authenticationViewModel.isLogin) {
            props.onNavigate(history, '/login')
        }
    }
    const onShowMainPage = () => {
        props.onNavigate(history, '/')
    }
    const onShowBasketPage = () => {
        props.onNavigate(history, '/basket')
    }

    function getCategoryParents() {
        let categories = categoryViewModel.getCategories()
        if (categories.length > 0) {
            return categories.map((category) => {
                let selectedIsThis = selectedCategory ? category.id === selectedCategory.id : undefined
                return <div key={category.id}>
                    {selectedIsThis &&
                    <Divider/>
                    }
                    <IconTitleButton
                        width="99%"
                        textcolor={selectedIsThis ? 'var(--blue_5)' : 'var(--black)'}
                        fontSize="mediumTextBold"
                        hover={'var(--blue_5)'}
                        barcolor={'var(--blue_5)'}
                        borderradius={'0'}
                        showbar={selectedIsThis.toString()}
                        hasaftericon={selectedIsThis.toString()}
                        onMouseEnter={() => {
                            categoryViewModel.setSelectedCategory(category)
                            categoryViewModel.setSelectedCategoryChild(category.childs[0])
                        }}
                        title={category.title}
                        onClick={() => {
                            onShowCategoryPage()
                        }}/>
                    {selectedIsThis &&
                    <Divider/>
                    }
                </div>
            })
        }
    }

    function getSelectedCategoryChilds() {
        if (selectedCategory) {
            return selectedCategory.childs.map((child) => {
                const onClick = () => {
                    setSelectedCategoryChild(child)
                    onShowCategoryPage(child)
                    onHideCategoryMenu()
                    onCategoryPopperMouseOut()
                }
                let selectedIsThis = selectedCategoryChild && child.id === selectedCategoryChild.id
                return <div key={child.id} style={{marginRight: "1em"}}>
                    <Animated
                        animationIn="slideInDown"
                        animationInDuration={200}
                        isVisible={true}>
                        <IconTitleButton
                            width="99%"
                            textcolor={selectedIsThis ? 'var(--blue_5)' : 'var(--black)'}
                            hover={'var(--blue_5)'}
                            barcolor={'var(--blue_5)'}
                            showbar={selectedIsThis.toString()}
                            fontSize={selectedIsThis ? 'mediumTextBold' : 'mediumText'}
                            title={child.title}
                            onClick={onClick}
                            onMouseEnter={() => {
                                categoryViewModel.setSelectedCategoryChild(child)
                            }}/>
                    </Animated>
                </div>
            })
        }
    }

    function getLogoutDialogMessage() {
        return <DialogMessage
            showStatus={logoutDialogShowStatus}
            title={messages.logout}
            message={messages.sureLogout}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setLogoutDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setLogoutDialogShowStatus(false)
                authenticationViewModel.logout()
                props.onNavigate(history, '/')
                window.location.reload()
            }}
        />
    }

    function getCategoryMenu() {
        let categories = categoryViewModel.getCategories()
        if (categories && categories.length > 0) {
            return <Popper
                className="highZIndex_3 categoryMenu categoryMenuShowStatus"
                open={categoryButtonOver || categoryPopperOver} anchorEl={categoryAnchor}
                role={undefined} transition disablePortal
                onMouseEnter={onCategoryPopperMouseEnter}
                onMouseLeave={onCategoryPopperMouseOut}>
                {({TransitionProps}) => (
                    <Grow {...TransitionProps}>
                        <div className="shadow">
                            <Paper style={{
                                textAlign: "right",
                                backgroundImage: "linear-gradient(to top left, #5a189a30," +
                                    " #ffffff, #ffffff)"
                            }}>
                                <div className="horizontalScreen">
                                    <div style={{width: "25%"}}>
                                        {getCategoryParents()}
                                    </div>
                                    <div>
                                        <Divider orientation={"vertical"}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        {getSelectedCategoryChilds()}
                                    </div>
                                    <div style={{
                                        position: "absolute", bottom: 10,
                                        left: 10, height: "80%", opacity: "80%"
                                    }}>
                                        <CrossfadeImage
                                            duration={200}
                                            containerClass="fullHeight"
                                            src={selectedCategory && selectedCategory.image}/>
                                    </div>
                                </div>
                            </Paper>
                        </div>
                    </Grow>
                )}
            </Popper>
        }
    }

    function getProfileMenu() {
        let profileMenuItems = [
            {
                id: 1,
                title: messages.account,
                icon: <ICUserAccount className="grayColor_4"/>,
                onItemClicked: () => {
                    onShowloginOrProfilePage()
                }
            },
            {
                id: 2,
                title: messages.myAddress,
                icon: <ICAddress className="grayColor_4"/>,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    onShowAddressPage()
                }
            },

            {
                id: 4,
                title: messages.myRewards,
                icon: <ICReward className="grayColor_4"/>,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    onShowRewardsPage()
                }
            },
            {
                id: 3,
                title: messages.wallet,
                icon: <ICWalllet className="grayColor_4"/>,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    onShowWalletPage()
                }
            },
            {
                id: 5,
                title: messages.inviteFriends,
                icon: <ICInvite className="grayColor_4"/>,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    props.onNavigate(history, '/inviteFriend')
                }
            },
            {
                id: 6,
                title: messages.criticsAndSuggestion,
                icon: <img src={ICTicket} style={{width:'1.5rem'}}  className="grayColor_4"/>,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    props.onNavigate(history, '/suggestion?p=1')
                }
            },
            {
                id: 7,
                title: messages.logout,
                textcolor: "var(--red_1)",
                icon: <ICLogOut className="redColor" />,
                onItemClicked: () => {
                    onHideProfileMenu()
                    onProfilePopperMouseOut()
                    setLogoutDialogShowStatus(true)
                }
            }
        ]

        const profileMenu = <div>
            <div className="largeTextBold center clickable singleLine"
                 style={{marginTop: "0.5em"}}
                 onClick={() => {
                     onShowloginOrProfilePage()
                 }}>
                {(user && user.full_name) ?
                    user.full_name + messages.welcome :
                    messages.dearUser + messages.welcome
                }
            </div>
            <div style={{height: "1.0em"}}/>
            <Divider/>
            <div>
                {profileMenuItems.map((item) => {
                    let textcolor = 'var(--black)'
                    if (item.textcolor) {
                        textcolor = item.textcolor
                    }
                    return <div key={item.id} style={{margin: "0.3em", height: "2.5em"}}>
                        <IconTitleButton
                            width="99%"
                            hover={'var(--blue_5)'}
                            fontSize="largeText"
                            textcolor={textcolor}
                            icon={item.icon}
                            title={item.title}
                            onClick={() => {
                                item.onItemClicked()
                            }}/>
                    </div>
                })}
            </div>
        </div>

        if (IsLP_MP_SP()) {
            return <Popper
                className="highZIndex_3 tollbar_user_menu"
                open={profileButtonOver || profilePopperOver} anchorEl={profileAnchor}
                role={undefined} transition disablePortal
                onMouseEnter={onProfilePopperMouseEnter}
                onMouseLeave={onProfilePopperMouseOut}>
                {({TransitionProps}) => (
                    <Grow {...TransitionProps}>
                        <div className={"shadow marginTopBottomSmall"}>
                            <Paper
                                style={{
                                    textAlign: "right",
                                    backgroundImage: "linear-gradient(to top right, #5a189a30," +
                                        "#ffffff, #ffffff)", padding: "0.5em", height: "100%"
                                }}>
                                {profileMenu}
                            </Paper>
                        </div>
                    </Grow>
                )}
            </Popper>
        } else {
            return <div>
                <React.Fragment key={'left'}>
                    <SwipeableDrawer
                        anchor={"left"}
                        open={sideMenuState["left"]}
                        onClose={onShowSideMenu("left", false)}
                        onOpen={onShowSideMenu("left", true)}>
                        <div style={{padding: "1em"}}
                             role="presentation"
                             onClick={onShowSideMenu("left", false)}
                             onKeyDown={onShowSideMenu("left", false)}>
                            {profileMenu}
                        </div>
                    </SwipeableDrawer>
                </React.Fragment>
            </div>
        }
    }

    const onShowCategoryPage = (categoryChild) => {
        if (IsLP_MP_SP()) {
            let category = categoryChild ? categoryChild : selectedCategoryChild
            props.onNavigate(history, '/category?c=' + category.id + "&p=1")
        } else {
            props.onNavigate(history, '/gridCategory')
        }
    }

    function seenDownloadApp() {
        localStorage.setItem("clickOnDownloadApp", 1)
        setDownloadAppState(1)
    }

    function requestDynamicData() {
        let params = new FormData();
        params.append("header_type", 10);
        callApi(Urls.getHomeDynamicData, params, (data) => {
            if (isCancelled) return

            let arrayBanners=[];
            let sumHeightBanner=0

            data.dynamic_data && data.dynamic_data.map((listItem, i) => {
                if(listItem.header && listItem.header.type && listItem.header.type==="10"){
                    if(listItem.lines && listItem.lines.length>0){
                        listItem.lines.map((lineItem, key) => {
                            arrayBanners[key]=  lineItem;
                            sumHeightBanner+=parseInt(lineItem.height);
                        })
                    }
                }
            })

            setBannerHeight(sumHeightBanner)
            setBanners(arrayBanners)
            setDynamicData(data.dynamic_data)

        }, () => {
            setDynamicData([])
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    useEffect(() => {
            requestDynamicData()

    },[])

    useEffect(() => {

        categoryViewModel.selectedCategory.subscribe((selectedCategory) => {
            if (isCancelled) return

            setSelectedCategory(selectedCategory)
        })
        categoryViewModel.selectedCategoryChild.subscribe((selectedCategoryChild) => {
            if (isCancelled) return

            setSelectedCategoryChild(selectedCategoryChild)
        })
        authenticationViewModel.user.subscribe((user) => {
            if (isCancelled) return

            setUser(user)
        })
        window.onscroll = () => {
            let lastPosition = localStorage.getItem('lastPosition') ?
                parseInt(localStorage.getItem('lastPosition')) : 0
            localStorage.setItem("lastPosition", window.pageYOffset)
            if (window.pageYOffset > lastPosition) {
                setGoToTopShowStatus(true)
            } else {
                setGoToTopShowStatus(false)
            }
        }
        return () => {
            setIsCancelled(true)
        }
    }, [isCancelled])

    return (<div>
        <Switch>
            <Route path='/afterPayment' render={(_) => (
                <AfterPayment {...props}/>
            )}/>
            <Route path='/afterWalletPayment' render={(_) => (
                <AfterWalletPayment {...props}/>
            )}/>
            <Route path='/landing' render={(_) => (
                <Landing {...props}/>
            )}/>
            <Route path='/beforePayment' render={(_) => (
                <BeforePayment {...props}/>
            )}/>
            <Route path='/beforeWalletPayment' render={(_) => (
                <BeforeWalletPayment {...props}/>
            )}/>
            <Route path='/login' render={(_) => (
                <Login {...props}/>
            )}/>
            <Route path='/verify' render={(_) => (
                <Verify {...props}/>
            )}/>
            <Route path='/orderRate' render={(_) => (
                <OrderRate {...props}/>
            )}/>
            <Route path='/orderRate' render={(_) => (
                <OrderRate {...props}/>
            )}/>
            {routes.map((route) => {
                let marginTopmain= IsLP() ? "160" : IsMP() ? "152" : IsSP() ? "152" : IsT() ? "136" : IsF() ? "124.8" : IsM() ? "115.2" : "104";
                marginTopmain=bannerHeight>0 ? parseInt(marginTopmain)+parseInt(bannerHeight) : parseInt(marginTopmain);
                return <Route
                    key={route.id}
                    path={route.path} exact={route.exact}
                    render={(_) => {
                        return (   <div>
                            {banners && banners.length>0 ? (<TopBanner banners={banners}   onClicked={(slider) => {
                                props.onBannerClicked(history, slider)
                            }} /> ): <div />}

                            <Toolbar
                                {...props}
                                onShowBasketPage={onShowBasketPage}
                                onShowMainPage={onShowMainPage}
                                onShowNotificationPage={onShowNotificationPage}
                                onShowSuggestionPage={onShowSuggestionPage}
                                onShowAddTicketPage={onShowAddTicketPage}
                                onShowOrdersPage={onShowOrdersPage}
                                onShowLoginPage={onShowLoginPage}
                                onShowSideMenu={onShowSideMenu}
                                onShowCategoryPage={onShowCategoryPage}
                                onShowCategoryMenu={onShowCategoryMenu}
                                onHideCategoryMenu={onHideCategoryMenu}
                                onShowProfileMenu={onShowProfileMenu}
                                onShowRewardsPage={onShowRewardsPage}
                                onShowWalletPage={onShowWalletPage}
                                bannerHeight={bannerHeight}
                                onHideProfileMenu={onHideProfileMenu}/>
                            <div className="main"
                                 style={{marginTop:marginTopmain+"px"}}>
                                <route.component {...props} homeData={dynamicData}/>
                                <div
                                    className="highZIndex_1"
                                    style={{
                                        position: 'fixed',
                                        bottom: '20px',
                                        right: '20px',
                                        opacity: '80%',
                                        display: goToTopShowStatus ? "block" : "none"
                                    }}>
                                    <CircleIconButton
                                        hover={"var(--blue_2)"}
                                        background={"var(--blue_2)"}
                                        width={"1.8em"} height={"1.8em"}
                                        icon={<img src={ICArrow} className="xSmallIcon" alt=""/>}
                                        onClick={() => {
                                            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                                        }}/>
                                </div>
                            </div>
                            <Footer {...props}/>
                        </div>)
                    }}/>
            })}
        </Switch>
        {getCategoryMenu()}
        {(user && user.token) &&
        getProfileMenu()
        }
        {getLogoutDialogMessage()}
        <DownloadApp
            showStatus={downloadAppState !== 1}
            onClick={(history) => {
                seenDownloadApp()
                props.onNavigate(history, "/download")
            }}
            onCloseClicked={() => {
                seenDownloadApp()
            }}/>
    </div>)

}